<template>
  <div>
    <v-dialog persistent v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline white subtitle-1">{{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn            
            color="#444"
            style="color:#ffffff"
            @click.native="disagree"
          >{{ cancel }}</v-btn>
          <v-btn            
            color="primary"
            @click.native="agree"
          >
            <span class="font-weight-light body-2 ">{{ ok }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      message: "",
      title: "Confirmer",
      ok: "Oui",
      cancel: "Annuler",
      resolve: null,
      reject: null
    };
  },
  methods: {
    show(title, message, ok, cancel) {
      if (message) this.message = message;
      this.title = title;
      if (ok) this.ok = ok;
      if (cancel) this.cancel = cancel;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    disagree() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
</style>